import {Button} from '../../../button/button';
import {PaperPlane} from '../../../icon';
import {Stack} from '../../../layout/stack/stack';

import {SendButton} from './send-button';
import {MODE} from './types';
import type {Mode, SendInput} from './types';

import styles from './inbox-rich-text-input.module.css';

interface Props {
    isSendDisabled: boolean;
    onNoteCreate: () => Promise<unknown>;
    onSend: (input?: SendInput | null | undefined) => Promise<unknown>;
    isSending: boolean;
    showSnoozeOptions?: boolean;
    mode: Mode;
}

export function EmailInputFooter(props: Props) {
    const isEmailMode = props.mode === MODE.EMAIL;

    return (
        <div className={styles['footer-container']}>
            {isEmailMode ? (
                <SendButton
                    isDisabled={props.isSendDisabled}
                    onSend={props.onSend}
                    isSending={props.isSending}
                    showSnoozeOptions={props.showSnoozeOptions}
                />
            ) : (
                <Button
                    variant='primary'
                    size='big'
                    onClick={props.onNoteCreate}
                    disabled={props.isSendDisabled}
                >
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        <PaperPlane size={14} />
                        {props.isSending ? 'Adding…' : 'Add note'}
                    </Stack>
                </Button>
            )}
        </div>
    );
}
